import React from "react";
import PropTypes from "prop-types";
import Main from "../components/Main/";
import { connect } from "react-redux";
import injectSheet from "react-jss";
require("core-js/fn/array/find");
require("prismjs/themes/prism-okaidia.css");

import { setNavigatorPosition, setNavigatorShape } from "../state/store";
import { moveNavigatorAside } from "../utils/shared";
import Post from "../components/Post/";
import Footer from "../components/Footer/";
import Seo from "../components/Seo";
import LazyLoad from "react-lazyload";

const styles = theme => ({
  postBG: {
    backgroundColor: "black",
    zIndex: "-5",
    width: "85vw",
    position: "fixed"
  },
  title: {
    color: "white",
    fontSize: `${theme.main.fonts.title.size}em`,
    letterSpacing: "-0.04em",
    fontWeight: 500,
    fontStyle: "italic",
    lineHeight: theme.main.fonts.title.lineHeight,
    margin: "0 0 0.4em",
    [`@media (min-width: ${theme.mediaQueryTresholds.M}px)`]: {
      fontSize: `${theme.main.fonts.title.sizeM}em`
    },
    [`@media (min-width: ${theme.mediaQueryTresholds.L}px)`]: {
      fontSize: `${theme.main.fonts.title.sizeL}em`,
      letterSpacing: "-0.05em"
    },
    marginTop: "45%",
    marginLeft: "3%"
  },
  meta: {
    fontSize: "17px",
    fontWeight: 400,
    color: "#FAB0B0",
    marginLeft: "4%"
  }
});
class PostTemplate extends React.Component {
  moveNavigatorAside = moveNavigatorAside.bind(this);

  componentDidMount() {
    if (this.props.navigatorPosition === "is-featured") {
      this.moveNavigatorAside();
    }
  }

  render() {
    const { classes, data, pathContext } = this.props;
    const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook;
    const frontmatter = (data.post || {}).frontmatter;
    const background = frontmatter.background;
    const date = ((data.post || {}).fields || {}).prefix;

    function myDate(dateString) {
      const dateObj = new Date(dateString).toUTCString();
      const dateToShow = dateObj
        .split(" ")
        .slice(0, 4)
        .join(" ");

      return dateToShow;
    }

    // pull out title and data here
    const title = frontmatter.title;

    return (
      <Main>
        <LazyLoad>
          <picture className={classes.postBG}>
            <source type="image/webp" srcSet={background.children[0].resolutions.srcSetWebp} />
            <source srcSet={background.children[0].resolutions.srcSet} />
            <img className={classes.postBG} src={background.children[0].resolutions.src} alt="" />
          </picture>
        </LazyLoad>
        <h1 className={classes.title}>{title}</h1>
        <h2 className={classes.meta}>{myDate(date)}</h2>
        <Post post={data.post} slug={pathContext.slug} author={data.author} facebook={facebook} />
        <Footer footnote={data.footnote} />
        <Seo data={data.post} facebook={facebook} />
      </Main>
    );
  }
}

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.object.isRequired,
  navigatorPosition: PropTypes.string.isRequired,
  setNavigatorPosition: PropTypes.func.isRequired,
  isWideScreen: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    navigatorPosition: state.navigatorPosition,
    isWideScreen: state.isWideScreen
  };
};

const mapDispatchToProps = {
  setNavigatorPosition,
  setNavigatorShape
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectSheet(styles)(PostTemplate));

//eslint-disable-next-line no-undef
export const postQuery = graphql`
  query PostBySlug($slug: String!) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      htmlAst
      fields {
        slug
        prefix
      }
      frontmatter {
        title
        background {
          children {
            ... on ImageSharp {
              resolutions(width: 1800, height: 1300) {
                ...GatsbyImageSharpResolutions_withWebp_noBase64
              }
            }
          }
        }
        cover {
          childImageSharp {
            resize(width: 300) {
              src
            }
          }
        }
      }
    }
    author: markdownRemark(id: { regex: "/author/" }) {
      id
      html
    }
    footnote: markdownRemark(id: { regex: "/footnote/" }) {
      id
      html
    }
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/PostTemplate.js